import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const QUOTES = [
  "Your circumstances are your starting coordinates, not your destination.",
  "Every decision creates a direction.",
  "The future is a muscle. You train it with choices.",
  "You cannot predict a life — but you can design one.",
  "The brave version of you is already alive. Give them the wheel.",
  "Small moves, compounded, become destinies.",
];

export const MotivationStrip = () => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % QUOTES.length), 6500);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="relative overflow-hidden h-6 md:h-7" data-testid="motivation-strip">
      <AnimatePresence mode="wait">
        <motion.p
          key={idx}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.6 }}
          className="font-mono-label text-center"
          style={{ color: "rgba(255,255,255,0.55)", letterSpacing: "0.18em" }}
        >
          {QUOTES[idx]}
        </motion.p>
      </AnimatePresence>
    </div>
  );
};
